import { Facebook, Send, Share2 } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/lib/i18n";
import { sendReaderEvent } from "@/lib/readerEvents";

export default function ShareButtons({ url, title, articleId, slug }) {
    const { t, lang } = useLang();
    const clicked = (target) => () => sendReaderEvent("share_click", { articleId, slug, lang, target });   // a click, not a completed share
    const shareUrl = encodeURIComponent(url);
    const shareTitle = encodeURIComponent(title);
    const wa = `https://api.whatsapp.com/send?text=${shareTitle}%20${shareUrl}`;
    const fb = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
    const tg = `https://t.me/share/url?url=${shareUrl}&text=${shareTitle}`;

    const copy = async () => {
        clicked("copy")();
        try { await navigator.clipboard.writeText(url); toast.success(t("linkCopied")); } catch { toast.error(t("copyFail")); }
    };

    return (
        <div className="flex flex-wrap items-center gap-2">
            <a href={fb} target="_blank" rel="noreferrer" onClick={clicked("facebook")} className="inline-flex items-center gap-2 bg-[#1877F2] hover:opacity-90 text-white text-xs font-bold px-3 py-2 rounded-sm" data-testid="share-facebook-button">
                <Facebook className="w-4 h-4" /> {t("facebook")}
            </a>
            <a href={wa} target="_blank" rel="noreferrer" onClick={clicked("whatsapp")} className="inline-flex items-center gap-2 bg-[#25D366] hover:opacity-90 text-white text-xs font-bold px-3 py-2 rounded-sm" data-testid="share-whatsapp-button">
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor"><path d="M20.52 3.48A11.87 11.87 0 0012.06 0C5.54 0 .24 5.3.24 11.82c0 2.08.55 4.11 1.6 5.9L0 24l6.44-1.68a11.83 11.83 0 005.62 1.43h.01c6.51 0 11.81-5.3 11.81-11.82 0-3.16-1.23-6.13-3.36-8.45zM12.07 21.4a9.6 9.6 0 01-4.9-1.34l-.35-.21-3.82 1 1.02-3.72-.23-.38a9.53 9.53 0 01-1.46-5.05c0-5.28 4.3-9.58 9.58-9.58 2.56 0 4.97 1 6.78 2.81a9.53 9.53 0 012.8 6.77c0 5.28-4.29 9.7-9.42 9.7z"/></svg>
                {t("whatsapp")}
            </a>
            <a href={tg} target="_blank" rel="noreferrer" onClick={clicked("telegram")} className="inline-flex items-center gap-2 bg-[#0088cc] hover:opacity-90 text-white text-xs font-bold px-3 py-2 rounded-sm" data-testid="share-telegram-button">
                <Send className="w-4 h-4" /> {t("telegram")}
            </a>
            <button onClick={copy} className="inline-flex items-center gap-2 bg-gray-800 hover:bg-black text-white text-xs font-bold px-3 py-2 rounded-sm" data-testid="share-copy-button">
                <Share2 className="w-4 h-4" /> {t("copy")}
            </button>
        </div>
    );
}
